import { useState } from "react";
import ModeSelectionStep from "./modeSelectionStep/modeSelectionStep";
import { Button } from "@alpaca/framework";
import "./inviteWizard.styles.scss";
import InviteUserStep from "./inviteUserStep/inviteUserStep";
import ConfirmationStep from "./confirmationStep/confirmationStep";
import CreateUserStep from "./createUserStep/createUserStep";

import { validateCreateUserForm } from "../utils/InviteWizardValidators";

const InviteWizard = ({ permissions, onUserCreate, onInviteUser, onClose }) => {
  const [mode, setMode] = useState("start");
  const [step, setStep] = useState(0);

  const [newUserProfile, setNewUserProfile] = useState({});
  const [validationErrors, setValidationErrors] = useState({});

  const [invites, setInvites] = useState([]);
  const inviteUserSteps = [
    {
      title: "Invite a User",
      content: (
        <InviteUserStep
          permissions={permissions}
          invites={invites}
          setInvites={setInvites}
        />
      ),
      nextAction: "Send Invite(s)",
      onAction: async () => {
        if (invites.length === 0) return; // throw error?
        return onInviteUser(invites);
      },
    },
    {
      title: "Confirmation",
      content: <ConfirmationStep mode={mode} />,
      nextAction: "Close this Window",
      onAction: () => {
        onClose();
      },
    },
  ];

  function isValidInvite(newUserProfile) {
    return (
      newUserProfile.lastName &&
      newUserProfile.firstName &&
      newUserProfile.email &&
      newUserProfile.password &&
      newUserProfile.username
    );
  }

  const createUserSteps = [
    {
      title: "Create a User",
      content: (
        <CreateUserStep
          permissions={permissions}
          newUserProfile={newUserProfile}
          setNewUserProfile={setNewUserProfile}
          validationErrors={validationErrors}
        />
      ),
      nextAction: "Create User",
      onAction: async () => {
        const errors = await validateCreateUserForm(newUserProfile);
        if (errors) {
          setValidationErrors(errors);
          return false;
        }
        await onUserCreate(newUserProfile);
        return true;
      },
    },
    {
      title: "Confirmation",
      content: <ConfirmationStep mode={mode} />,
      nextAction: "Close this Window",
      onAction: () => {
        onClose();
      },
    },
  ];

  const getStepAction = () => {
    if (step === 0) {
      return "Next";
    }
    if (mode === "invite") {
      return inviteUserSteps[step - 1].nextAction;
    }
    return createUserSteps[step - 1].nextAction;
  };

  const handleNext = async (selectedMode) => {
    if (step === 0 && !selectedMode) {
      alert("Please choose an option before proceeding.");
      return;
    }

    if (step > 0) {
      if (mode === "create") {
        const currentStep = createUserSteps[step - 1];
        if (currentStep.onAction) {
          const result = await currentStep.onAction();
          if (result === false) return;
        }
      } else {
        const currentStep = inviteUserSteps[step - 1];
        if (currentStep.onAction) {
          const result = await currentStep.onAction();
          if (result === false) return;
        }
      }
    }

    if (!isLastStep(step)) {
      setStep(step + 1);
    } else {
      onClose();
      // setStep(0);
      // setMode("start");
      // setNewUserProfile({});
      // setValidationErrors({});
      // setInvites([]);
    }
  };

  const handlePrevious = () => {
    setStep(step - 1);
  };

  const renderStepContent = () => {
    if (step === 0) {
      return (
        <ModeSelectionStep
          mode={mode}
          setMode={(mode) => {
            setMode(mode);
            handleNext(mode);
          }}
        />
      );
    }

    if (mode === "invite") {
      return inviteUserSteps[step - 1].content;
    }
    return createUserSteps[step - 1].content;
  };

  function isLastStep(step) {
    if (mode === "invite") {
      return inviteUserSteps.length === step;
    }
    return createUserSteps.length === step;
  }

  return (
    <>
      {
        <div className="">
          <div className="">
            <div className="">{renderStepContent()}</div>

            <div className="invite__wizard__buttons">
              {isLastStep(step) && mode === "create" && (
                <Button
                  onClick={() => {
                    setNewUserProfile({});
                    setValidationErrors({});
                    setStep(1);
                  }}
                  type="primary"
                  size="large"
                >
                  Create Another User
                </Button>
              )}

              {step !== 0 && !isLastStep(step) && (
                <>
                  <Button onClick={handlePrevious} size="large">
                    Back
                  </Button>
                </>
              )}
              {step !== 0 && (
                <Button
                  type="primary"
                  size="large"
                  onClick={handleNext}
                  disabled={
                    (mode === "invite" && invites.length === 0 && step === 1) ||
                    (mode === "create" &&
                      !isValidInvite(newUserProfile) &&
                      step === 1)
                  }
                >
                  {getStepAction()}
                </Button>
              )}
            </div>
          </div>
        </div>
      }
    </>
  );
};

export default InviteWizard;
